module.exports = __webpack_public_path__ + "img/m-topic@1x.e09b860a.png";